(function() {
    'use strict';
    angular
        .module('Services').service('AffiliateService', AffiliateService);

        AffiliateService.$inject = ['Request'];

        function AffiliateService(Request) {
            var service = {
                getAllcompanyPartners : function(callback, errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getCompanyMarketing,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                companyReportSummary : function(callback, errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.reportSummary,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                createPartnerCompany : function(callback, errCallback,payload){
                    Request.post({
                        url : ApiURLs.affiliate.create,
                        method : 'POST',
                        successCallback: callback,
                        errorCallback: errCallback
                    }, payload)
                },
                deletePartnerCompany : function(callback, errCallback,id){
                    Request.delete({
                        url : ApiURLs.affiliate.delete.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    })
                },
                getCompanyDetails : function(callback, errCallback,id){
                    Request.get({
                        url: ApiURLs.affiliate.getCompanyDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback,
                    });
                },
                updateCompanyDetails : function(id,callback, errCallback,data){
                    Request.post({
                        url: ApiURLs.affiliate.update.replace(':id',id),
                        method:'PUT',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },data);
                },
                // Referred Company
                getAllcompanyReferred : function(callback, errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getAllReferredCompany,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                getReferredDetails :  function (id,callback,errCallback){
                    Request.get({
                        url: ApiURLs.affiliate.getReferredDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                createCompanyReferred : function(callback, errCallback,data){
                    Request.post({
                        url: ApiURLs.affiliate.getAllReferredCompany,
                        method : 'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },data);
                },
                unassignedCompanyReferred : function(callback, errCallback,id){
                    Request.post({
                        url: ApiURLs.affiliate.unassignedCompany.replace(':id',id),
                        method : 'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                    });
                },
                // Promo code
                createPromoCode :function(callback, errCallback,payload){
                    Request.post({
                        url: ApiURLs.affiliate.createPromoCode,
                        method:'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },payload);
                },
                updatePromoCode :function(id,callback, errCallback,payload){
                    Request.post({
                        url: ApiURLs.affiliate.updatePromoCode.replace(':id',id),
                        method:'PUT',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },payload);
                },
                deletePromoCode : function (callback,errCallback,id){
                    Request.delete({
                        url : ApiURLs.affiliate.deletePromoCode.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    })
                },
                getPromoCodeDetails : function (id,callback,errCallback){
                    Request.get({
                        url : ApiURLs.affiliate.getPromoCodeDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    })
                },
                getAllPromoCode : function(callback, errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getAllPromoCode,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                // User Marketing 
                userMarketingDetails : function(callback, errCallback,id){
                    Request.get({
                        url: ApiURLs.affiliate.userMarketingDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                createUserMarketing : function (callback, errCallback,payload){
                    Request.post({
                        url: ApiURLs.affiliate.createUserMarketing,
                        method:'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },payload);
                },
                updateUserMarketing :function(id,callback, errCallback,payload){
                    Request.post({
                        url: ApiURLs.affiliate.updateUserMarketing.replace(':id',id),
                        method:'PUT',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },payload);
                },
                getUserMarketing: function(callback, errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getAllUserMarketing,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                subAffiliateDetails:function(id,callback,errCallback){
                    Request.get({
                        url: ApiURLs.affiliate.subAffiliateDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                deleteUserMarketing : function(callback,errCallback,id){
                    Request.delete({
                        url: ApiURLs.affiliate.userMarketingDetails.replace(':id',id),
                        successCallback: callback,
                        errorCallback: errCallback
                    });
                },
                getAllReportAproval : function(callback ,errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getAllReportAproval,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                exportApprovedCSV:function(ids,type,callback, errCallback){
                    Request.post({
                        url: ApiURLs.affiliate.exportApprovedCSV+'?commissionStatus='+type,
                        method:'POST',
                        successCallback: callback,
                        errorCallback: errCallback,
                    },ids);
                },
                approveReport:function (id,callback, errCallback){
                    Request.post({
                        url: `${ApiURLs.affiliate.getAllReportAproval}/${id}/approve`,
                        method:'PATCH',
                        successCallback: callback,
                        errorCallback: errCallback,
                    });
                },
                rejectReport:function (id,callback, errCallback){
                    Request.post({
                        url: `${ApiURLs.affiliate.getAllReportAproval}/${id}/reject`,
                        method:'PATCH',
                        successCallback: callback,
                        errorCallback: errCallback,
                    });
                },
                getTransactionHistory : function(callback ,errCallback, data){
                    Request.get({
                        url: ApiURLs.affiliate.getTransactionHistory,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                },
                exportCSV :  function(successCallback, errorCallback,ids,data) { 
                    Request.post({
                        url: ApiURLs.affiliate.exportsCSV, 
                        method: 'POST', 
                        successCallback: successCallback, 
                        errorCallback: errorCallback,
                        data:data
                    }, ids);
                },
                exportByReferred: function(fileName,successCallback, errorCallback,params,requestData) { 
                    Request.exportFile({
                        fileName: fileName || 'export-transaction.csv', 
                        url: ApiURLs.affiliate.exportReferredCSV, 
                        data: params, 
                        fileType: 'text/csv', 
                        successCallback: successCallback, 
                        errorCallback: errorCallback, 
                        responseType: 'arraybuffer', 
                        contentType: 'application/json'
                    }, requestData);
                },
                exportByCompany: function(fileName,successCallback, errorCallback,params,requestData) { 
                    Request.exportFile({
                        fileName: fileName || 'export-referred.csv', 
                        url: ApiURLs.affiliate.exportCompanyCSV, 
                        data: params, 
                        fileType: 'text/csv', 
                        successCallback: successCallback, 
                        errorCallback: errorCallback, 
                        responseType: 'arraybuffer', 
                        contentType: 'application/json'
                    }, requestData);
                },
                updateStatus:function(id,successCallback,errCallback,status){
                    const url =  `${ApiURLs.affiliate.createPromoCode}/:id/${status}`;
                    Request.post({
                        url: url.replace(':id',id),
                        method:'PATCH',
                        successCallback: successCallback,
                        errorCallback: errCallback
                    })
                },
                cleanPayload : function(userMarketingDetails){

                    const promoCodeIds =[];
                    if(userMarketingDetails.promoCodes){
                        userMarketingDetails.promoCodes.forEach(promo => {
                            promoCodeIds.push(promo.id)
                        });
                        
                        userMarketingDetails.promoCodeIds = promoCodeIds;
                    }
                    
                    userMarketingDetails.companyMarketingId = userMarketingDetails.companyMarketing.id;
                    userMarketingDetails.locationId = userMarketingDetails.location.id;

                    delete userMarketingDetails.companyMarketing;
                    delete userMarketingDetails.location;
                    delete userMarketingDetails.modifiedBy;
                    delete userMarketingDetails.modifiedDate;
                    delete userMarketingDetails.promoCodes;
                    
                    return userMarketingDetails
                }
            };

            return service;
        }
})();


// WEBPACK FOOTER //
// ./js/services/AffiliateService.js